import { Slide } from './components';
import Container from './Carousel';

export type { CarouselProps } from './Carousel.d';

export const Carousel = {
  Slide,
  Container,
};
